import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-guoneiqiache",
  "use": "icon-guoneiqiache-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-guoneiqiache\"><path d=\"M15.125 2.625a.5.5 0 01.5.5v8.75a.5.5 0 01-.5.5h-1.197a1.876 1.876 0 01-3.606 0h-4.64a1.876 1.876 0 01-3.615 0H.5a.125.125 0 01-.125-.125V7.88a.25.25 0 01.053-.154l2.402-3.09a.25.25 0 01.198-.096H6.37V3.125a.5.5 0 01.5-.5h8.255zM3.875 11a.875.875 0 100 1.75.875.875 0 000-1.75zm8.25-.016a.875.875 0 100 1.75.875.875 0 000-1.75zm2.5-7.359H7.37v1.563h.005v6.187h2.938a1.876 1.876 0 013.624 0h.688v-7.75zM6.375 5.54h-2.98l-.625.804h1.355c.07 0 .125.056.125.125v.593c0 .07-.056.125-.125.125H2.113l-.738.95v3.238h.692a1.876 1.876 0 013.616 0h.692V5.54z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/guoneiqiache.svg
// module id = 472
// module chunks = 4